import { getCookie, setCookie } from '.';

const TOKEN_KEY = 'biUserToken';

const isLogin = () => {
  return !!getCookie(TOKEN_KEY);
};

const getToken = () => {
  return getCookie(TOKEN_KEY);
};

const setToken = (token: string) => {
  setCookie(TOKEN_KEY, token);
};
const clearToken = () => {
  setCookie(TOKEN_KEY, '');
};

const getSSOID = () => {
  return import.meta.env.VITE_SSO_ID;
};
const goSSO = () => {
  const search = window.location.search;
  const newSearch = search.replace(/[?&]ticket=([^&]*)/, '');
  window.location.href =
    'https://sso.youxi123.com/login/' +
    getSSOID() +
    '?next=' +
    encodeURIComponent(
      window.location.origin + window.location.pathname + newSearch
    );
};

export { isLogin, getToken, setToken, clearToken, goSSO };
